import { useMemo } from 'react'
import { Select } from '../ui/Select'
import { useT } from '../../i18n/useT'
import { EXPORT_FORMATS } from '../../lib/subtitleConvert'
import type { OutputFormat } from '../../types/transcription'

/** The four that read as "{name} Subtitles"; the rest carry their name alone,
 * which is how they are written everywhere else in the product. */
const WORDED = new Set(['srt', 'vtt', 'ass', 'ssa'])

interface FormatSelectProps {
  value: OutputFormat
  onChange: (value: OutputFormat) => void
}

export function FormatSelect({ value, onChange }: FormatSelectProps) {
  const t = useT()
  const options = useMemo(
    () =>
      EXPORT_FORMATS.map(({ format, label }) => ({
        value: format,
        label:
          format === 'text'
            ? t('form.formatPlainText')
            : WORDED.has(format)
              ? t('form.formatSubtitles', { fmt: label })
              : label,
      })),
    [t],
  )
  return (
    <Select
      options={options}
      value={value}
      onChange={(v) => onChange(v as OutputFormat)}
      label={t('form.outputFormat')}
    />
  )
}
